import { lazy } from 'react';
import { MapPinned } from 'lucide-react';
import type { FeatureSection } from '@/app/registry';

/**
 * Markets: the header market's detail page (or the market list without one), each market's page (settings, geofences & hubs, prices,
 * deposits, voice, seasons), MDS policies and the global voice library.
 */
export const marketsSection: FeatureSection = {
  key: 'markets',
  title: 'markets',
  icon: MapPinned,
  routes: [
    // the market picked in the header; the old market list path leads here
    { path: '/markets/detail', legacyPath: '/markets/areas', title: 'marketDetail', resource: 'area', component: lazy(() => import('./areas/MarketDetailPage')) },
    { path: '/markets/areas/:areaId', title: 'market', resource: 'area', hideInMenu: true, component: lazy(() => import('./areas/AreaDetailPage')) },
    { path: '/markets/policies', title: 'mdsPolicies', resource: 'area', component: lazy(() => import('./policies/PoliciesPage')) },
    { path: '/markets/voice/library', title: 'voiceLibrary', resource: 'voice', component: lazy(() => import('./voice/VoiceLibraryPage')) },
  ],
};
